
  var _styles = {
  "slot-machine__reels-container": {
    "flexDirection": "row",
    "justifyContent": "space-between",
    "alignItems": "flex-start",
    "height": "2.66667rem",
    "overflow": "hidden",
    "borderRadius": "0.21333rem"
  },
  "slot-machine__reel": {
    "overflow": "hidden",
    "width": "1.6rem",
    "height": "2.66667rem"
  }
};



  module.exports = _styles;
  